module.exports = __webpack_public_path__ + "img/ao.bbe55a0.svg";